// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
// import ElementUI from 'element-ui';
import ElementUI from 'element-ui';
import Vuex from 'vuex'
import store from "./store";
import VueParticles from 'vue-particles' 
import 'element-ui/lib/theme-chalk/index.css'; 
import "./assets/css/style.scss";
import "./assets/css/fonts/fonts.css";
import "./init.js";
Vue.use(VueParticles)  
Vue.use(Vuex)
// Vue.use(ElementUI)
Vue.use(ElementUI);


Vue.config.productionTip = false
/*多语言翻译*/
// const i18n = new VueI18n({
//   //this.$i18n.locale // 通过切换locale的值来实现语言切换
//   locale:localStorage.getItem("lang")||"zh",//默认语言
//   messages: {
//     'zh': require('./assets/js/lang/zh.js'), // 中文语言包
//     'en': require('./assets/js/lang/en.js'), // 英文语言包
//   }
// });


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // i18n,
  store,
  components: { App,},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js